module.exports = __webpack_public_path__ + "static/media/next-icon.9db59933.svg";